import React, { ReactNode }                         from "react";
import { DndProvider }                              from "react-dnd";
import TouchBackend                                 from "react-dnd-touch-backend/";
import { connect }                                  from "react-redux";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import RecordTemplateForm                           from "../../components/record/template/RecordTemplateForm";
import RecordTemplateUpdateButton                   from "../../components/record/template/RecordTemplateUpdateButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
}

class RecordTemplateEditContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "記録テンプレート編集",
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "記録テンプレート一覧",
                path: "/record/templates"
              },
              {
                title: "記録テンプレート編集",
                path: "/record/template/edit"
              }
            ]
          }/>
        </TopSection>

        <TopSection>
          <RecordTemplateUpdateButton/>
          <BackHistoryButton path="/record/templates"/>
        </TopSection>

        <DndProvider backend={ TouchBackend } options={ {enableMouseEvents: true} }>
          <RecordTemplateForm/>
        </DndProvider>

        <BottomSection>
          <RecordTemplateUpdateButton/>
          <BackHistoryButton path="/record/templates"/>
        </BottomSection>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(RecordTemplateEditContainer);
